import React, { useEffect, useState } from "react";
import "./styles.scss";

import Checkbox from "../../common/checkbox";
import Button from "../../common/button";

import { ReactComponent as Backbtn } from "../../assets/icons/backbtn.svg";
import { useNavigate } from "react-router-dom";

import { postYourBundleList } from "../../store/homeAction/action";
import { useStateValue } from "../../store/index";

const BundleLayout = () => {
  const Navigate = useNavigate();
  const [{ bundleList }, dispatch] = useStateValue();
  const [selectedItem, setSelectedItem] = useState(
    JSON.parse(sessionStorage.getItem("user_bundle"))?.term_id
  );

  useEffect(() => {
    if (Object.keys(bundleList).length == 0) {
      dispatch({
        type: "SET_IS_LOADING",
        value: true,
      });
      postYourBundleList((res, error) => {
        dispatch({
          type: "SET_BUNDLE_LIST",
          data: res,
        });

        dispatch({
          type: "SET_IS_LOADING",
          value: false,
        });
        if (error) {
          dispatch({
            type: "SET_ALERT_MESSAGE",
            value: true,
            data: {
              severity: "error",
              message: "Something went wrong, Please try again.",
            },
          });
        }
      });
    }
  }, []);

  const handleUpdate = (event) => {
    setSelectedItem(event?.id);

    sessionStorage.setItem("user_bundle", JSON.stringify({ ...event?.item }));
  };

  return (
    <div className="bundle-layout-container">
      <Backbtn onClick={() => Navigate(-1)} className="back-btn" />
      {Object.keys(bundleList).length !== 0 && (
        <>
          <h3>{bundleList?.heading}</h3>
          <p dangerouslySetInnerHTML={{ __html: bundleList?.content }} />
          <Checkbox
            data={bundleList?.bundles}
            onClick={(data) => handleUpdate(data)}
            id={selectedItem}
          />
          <div className="btn">
            <Button
              onClick={() =>
                Navigate(`${process.env.REACT_APP_BASE}/bundle-listing`)
              }
            >
              View Bundle
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default BundleLayout;
